import React, { useState, useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import BranchList from "./BranchList";
import CreateBranchForm from "./CreateBranchForm";
import EditBranchForm from "./EditBranchForm";

const BranchPage = () => {
  const [activeTab, setActiveTab] = useState("list");
  const [editingBranchId, setEditingBranchId] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const { user } = useContext(AuthContext);

  // Check admin status - matches pattern used in Sidebar.jsx
  const isAdmin = user?.is_admin === true;

  const handleEdit = (branchId) => {
    setEditingBranchId(branchId);
    setActiveTab("edit");
  };

  const handleCreated = () => {
    setRefreshTrigger((prev) => prev + 1);
    setActiveTab("list");
  };

  const handleEditDone = () => {
    setEditingBranchId(null);
    setRefreshTrigger((prev) => prev + 1);
    setActiveTab("list");
  };

  return (
    <div className="container-fluid py-3 py-md-4">
      {/* Header */}
      <div className="row mb-3 mb-md-4">
        <div className="col">
          <h2 className="mb-1 h4 h2-md">
            <i className="bi bi-building me-2"></i>
            Branch/Office Management
          </h2>
          <p className="text-muted mb-0 small">
            Manage branch and office locations for invoice billing addresses
          </p>
        </div>
      </div>

      {/* Info Banner - Collapsible on mobile */}
      <div className="alert alert-info mb-3 mb-md-4">
        <div className="d-flex align-items-start">
          <i className="bi bi-info-circle me-2 mt-1 flex-shrink-0"></i>
          <div>
            <strong>About Branches/Offices:</strong>
            <span className="d-none d-sm-inline">
              {" "}These are used to identify different locations or regions for
              billing purposes. When assigned to a counselor, the branch name
              appears in the "Bill To" section on invoices.
            </span>
            <span className="d-sm-none">
              {" "}Used for billing locations on invoices.
            </span>
          </div>
        </div>
      </div>

      {/* Tabs - Responsive */}
      <ul className="nav nav-tabs mb-3 flex-nowrap overflow-auto">
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "list" ? "active" : ""} text-nowrap`}
            onClick={() => {
              setActiveTab("list");
              setEditingBranchId(null);
            }}
          >
            <i className="bi bi-list-ul me-1"></i>
            <span className="d-none d-sm-inline">All </span>Branches
          </button>
        </li>
        {isAdmin && (
          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === "create" ? "active" : ""} text-nowrap`}
              onClick={() => {
                setActiveTab("create");
                setEditingBranchId(null);
              }}
            >
              <i className="bi bi-plus-circle me-1"></i>
              <span className="d-none d-sm-inline">Create </span>
              <span className="d-sm-none">New</span>
              <span className="d-none d-sm-inline">Branch</span>
            </button>
          </li>
        )}
        {activeTab === "edit" && editingBranchId && (
          <li className="nav-item">
            <button className="nav-link active text-nowrap">
              <i className="bi bi-pencil me-1"></i>
              Edit<span className="d-none d-sm-inline"> Branch</span>
            </button>
          </li>
        )}
      </ul>

      {/* Tab Content */}
      <div className="card">
        <div className="card-body p-2 p-sm-3">
          {activeTab === "list" && (
            <BranchList
              onEdit={isAdmin ? handleEdit : null}
              refreshTrigger={refreshTrigger}
            />
          )}

          {activeTab === "create" && isAdmin && (
            <CreateBranchForm onCreated={handleCreated} />
          )}

          {activeTab === "edit" && editingBranchId && isAdmin && (
            <EditBranchForm
              branchId={editingBranchId}
              onDone={handleEditDone}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default BranchPage;